import { en } from "./en";
import { id } from "./id";
import type { Locale } from "../locale";

export type Dictionary = typeof en;

export const dictionaries: Record<Locale, Dictionary> = { en, id };
